import React, { createContext, useState, useContext } from 'react';
import { useAuth } from '../authContext';

const UserContext = createContext();
export const useUser = () => useContext(UserContext);
const profile = identity => ({ firstName: identity?.firstName || '', lastName: identity?.lastName || '', image: identity?.image || '' });
export const UserProvider = ({ children }) => {
  const { authData, sessionStatus } = useAuth();
  const identity = sessionStatus === 'ready' ? authData?.user : null;
  const [override, setOverride] = useState(null);
  const user = override?.identity === identity && identity ? override.user : profile(identity);
  const setUser = value => setOverride(current => ({ identity,
    user: typeof value === 'function' ? value(current?.identity === identity ? current.user : profile(identity)) : value }));
  return <UserContext.Provider value={{ user, setUser }}>{children}</UserContext.Provider>;
};
